import groups from "./competition/groups";
import matchs from "./competition/matchs";
import calendar from "./competition/calendar";
import scoreboard from "./competition/scoreboard";
import scoreboard_phase from "./competition/scoreboard_phase";
import injuries from "./competition/injuries";
import sanctions from "./competition/sanctions";

//STATS
import stats_top_scores from "./competition/stats/stats_top_scores";
import stats_team_scores from "./competition/stats/stats_team_scores";

import { Api } from "@/core/api.js";
const api = new Api();

const state = {
  phases: [],
  category_selected: -1,
  tmplteams: [],
  rounds: [],
  punishments: {}
};

const modules = {
  groups,
  matchs,
  calendar,
  scoreboard,
  scoreboard_phase,
  injuries,
  sanctions,
  stats_top_scores,
  stats_team_scores
};

// getters
const getters = {
  getListPhases: (state, getters, rootState) => id => {
    if (typeof id !== "undefined") return state.phases[id];
    return state.phases;
  },

  getListTmplTeams: (state, getters, rootState) => id => {
    if (typeof id !== "undefined") return state.tmplteams[id];
    return state.tmplteams;
  },

  getListRounds: (state, getters, rootState) => id => {
    if (typeof id !== "undefined") return state.rounds[id];
    return state.rounds;
  },

  getListRoundsByCategoryID: (state, getters, rootState) => id => {
    if (typeof id === "undefined") return [];
    var aRounds = Object.values(state.rounds).filter(round => {
      return (
        (round.group_id != null &&
          state.groups.list[round.group_id] &&
          state.groups.list[round.group_id].category_id == id) ||
        (round.phase_id != null &&
          state.phases[round.phase_id] &&
          state.phases[round.phase_id].category_id == id)
      );
    });

    return aRounds;
  },

  getCategorySelected: (state, getter, rootState) => {
    return state.category_selected;
  },

  getPunishments: (state, getter, rootState) => event_type_id => {
    if (typeof event_type_id === "undefined") return state.punishments;
    var data = [];
    for (var k in state.punishments) {
      var punishment = state.punishments[k];
      if (punishment.event_type_id == event_type_id) {
        data.push(punishment);
      }
    }

    return data;
  }
};

// actions
const actions = {
  loadPhases({ commit, getters, rootState }, params) {
    return api
      .get("competition/phase/event/" + params.event)
      .then(function(response) {
        if (response.status) {
          var data = response.data;
          for (var i in data) {
            data[i].is_visible = parseInt(data[i].visible) == 1;
            data[i].visible = true
            if (!params.no_modify_type) {
              data[i].type = "category";
            }
          }

          commit("setListPhases", data);
          return response;
        }
      });
  },

  loadTemplTeams({ commit, getters, rootState }, params) {
    return api
      .get("competition/tmplteam/event/" + rootState.events.current_event.id)
      .then(function(response) {
        if (response.status) {
          var data = response.data;
          for (var i in data) {
            data[i].visible = true;
          }

          return commit("setListTmplTeams", data);
        }
      });
  },

  loadRounds({ commit, getters, rootState }, params) {
    return api
      .get("competition/round/event/" + params.event)
      .then(function(response) {
        if (response.status) {
          var data = response.data;
          for (var i in data) {
            data[i].visible = true;
          }

          return commit("setListRounds", data);
        }
      });
  },

  assignTeamToTmpl(context, params) {
    return api
      .post(
        "competition/tmplteam/" +
          params.tmpl_team_id +
          "/assign/" +
          params.team_id,
        {}
      )
      .then(function(response) {
        if (response.status) {
          if(params.team_id != -1){
            let team = context.rootGetters["teams/getListKeyId"](params.team_id)
            context.commit("setTmplTeam", {id: params.tmpl_team_id, team: {id:team.id,name:team.name_abre && team.name_abre != '' ? team.name_abre : team.name,shield:team.club.shield}})
          } else {
            context.commit("setTmplTeam", {id: params.tmpl_team_id, team: null})
          }
          return true;
        } else {
          throw response.error.message;
        }
      });
  },

  changePhaseVisibility(context, params) {
    return api.post("competition/phase/" + params.phase_id + "/visible", {
      visible: params.is_visible
    }).then(function(response) {
      if(response.status) {
        context.commit("setPhaseVisibility", {id: params.phase_id, is_visible: params.is_visible})
        return response;
      }
    });
  },

  assignplayermatch(context,params){
    return api.post("match/" + params.match_id + "/team/" + params.team_id + "/player/" + params.player_id, {}).then(function(response){
      if(response.status){
        return response;
      }
    })
  }
};

// mutations
const mutations = {
  setListPhases(state, data) {
    state.phases = data;
  },

  setListTmplTeams(state, data) {
    state.tmplteams = data;
  },

  setTmplTeam(state, data) {
    let tmplTeams = {...state.tmplteams}
    tmplTeams[data.id].team = data.team
    state.tmplteams = tmplTeams;
  },

  setListRounds(state, data) {
    state.rounds = data;
  },

  changeCategory(state, name) {
    state.category_selected = name;
  },

  setPhaseVisibility(state, data) {
    state.phases[data.id].is_visible = data.is_visible;
  }
};

export default {
  namespaced: true,
  state,
  modules,
  getters,
  actions,
  mutations
};
